<template>
    <el-dialog title="操作日志详情" width="40%" :model-value="modelValue" @close="closed" :close-on-click-modal="false">
        <el-descriptions :column="6">
            <el-descriptions-item :span="3" label="操作类型">{{ dialogData && dialogData.action }}</el-descriptions-item>
            <el-descriptions-item :span="3" label="请求地址">{{ dialogData && dialogData.url }}</el-descriptions-item>
            <el-descriptions-item :span="3" label="用户信息">
                {{ dialogData && dialogData.username + '/' + dialogData.ip }}
            </el-descriptions-item>
            <el-descriptions-item :span="3" label="请求方式">{{ dialogData && dialogData.method }}</el-descriptions-item>
            <el-descriptions-item :span="6" label="操作信息">
                {{ dialogData && dialogData.desc }}
            </el-descriptions-item>
            <el-descriptions-item :span="6" label="请求参数">
                {{ dialogData && dialogData.params }}
            </el-descriptions-item>
            <el-descriptions-item :span="2" label="操作状态">
                {{ dialogData && dialogData.status ? '正常' : '失败' }}
            </el-descriptions-item>
            <el-descriptions-item :span="2" label="消耗时间">
                {{ dialogData && dialogData.cost_time + '毫秒' }}
            </el-descriptions-item>
            <el-descriptions-item :span="2" label="操作时间">{{ dialogData && dialogData.create_time }}</el-descriptions-item>
            <el-descriptions-item :span="2" label="异常信息" v-if="dialogData && dialogData.exception">
                {{ dialogData && dialogData.exception }}
            </el-descriptions-item>
        </el-descriptions>
        <template #footer>
            <span class="dialog-footer">
                <el-button @click="closed">取消</el-button>
            </span>
        </template>
    </el-dialog>
</template>
<script setup>
import { defineEmits, defineProps } from 'vue'

defineProps({
    modelValue: {
        type: Boolean,
        required: true
    },
    dialogData: {
        type: Object,
        required: true
    }
})

/**
 * 关闭
 */
const emits = defineEmits(['update:modelValue'])
const closed = () => {
    emits('update:modelValue', false)
}
</script>

<style lang="scss" scoped>
:deep(.el-descriptions__label:not(.is-bordered-label)) {
    font-weight: 700;
    color: var(--el-text-color-regular);
    font-size: 14px;
}

:deep(.el-descriptions__body .el-descriptions__table:not(.is-bordered) .el-descriptions__cell) {
    padding: 10px 0;
}
:deep(.el-descriptions__body) {
    max-height: 500px;
    overflow: auto;
}
</style>
